import { combineReducers } from "redux";

import { IInitialState } from "./states";

/** Reducers  */
import allergies from "./allergies";
import antibiotic from "./antibiotic";
import areas from "./areas";
import attachments from "./attachment";
import attachmentsIntegration from "./attachmentsIntegration";
import attest from "./attest";
import cares from "./cares";
import companies from "./companies";
import councils from "./councils";
import customerLogs from "./customerLogs";
import customers from "./customers";
import digitalSignature from "./digitalSignature";
import reasonDischarge from "./reasonDischarge";
import documentGroups from "./documentGroups";
import documents from "./documents";
import exams from "./exams";
import forms from "./forms";
import integrationDocuments from "./integrationDocuments";
import layout from "./layout";
import login from "./login";
import logo from "./logo";
import measurements from "./measurements";
import message from "./message";
import opinionAnswer from "./opinion";
import opinion from "./opinions";
import panel from "./panel";
import patients from "./patients";
import prescription from "./prescripition";
import profession from "./professions";
import qrCode from "./qrCode";
import revaluation from "./revaluation";
import specialties from "./specialties";
import telemedicine from "./telemedicine";
import telemedicineAttendances from "./telemedicineAttendances";
import users from "./users";
import monitoring from "./monitoring";

export default combineReducers<IInitialState>({
  areas,
  login,
  cares,
  companies,
  customers,
  specialties,
  councils,
  documents,
  documentGroups,
  patients,
  users,
  profession,
  layout,
  message,
  allergies,
  measurements,
  qrCode,
  prescription,
  antibiotic,
  exams,
  attest,
  logo,
  attachments,
  telemedicine,
  forms,
  customerLogs,
  attachmentsIntegration,
  opinion,
  opinionAnswer,
  panel,
  revaluation,
  telemedicineAttendances,
  digitalSignature,
  reasonDischarge,
  integrationDocuments,
  monitoring,
});
